export default "__VITE_ASSET__d12d5045__"